namespace TabAurous.OMS {
    export interface TargetMasterRow {
        TargetId?: number;
        EmployeeId?: number;
        BaseItemTypeId?: number;
        ProductTypeName?: string;
        UserId?: number;
        EmployeeName?: string;
        Quantity?: number;
        Amount?: number;
        TargetDistributionId?: number;
        FinancialYearId?: number;
        JanuaryTarget?: number;
        FebruaryTarget?: number;
        MarchTarget?: number;
        AprilTarget?: number;
        MayTarget?: number;
        JuneTarget?: number;
        JulyTarget?: number;
        AugustTarget?: number;
        SeptemberTarget?: number;
        OctoberTarget?: number;
        NovemberTarget?: number;
        DecemberTarget?: number;
        JanuaryAchieved?: number;
        FebruaryAchieved?: number;
        MarchAchieved?: number;
        AprilAchieved?: number;
        MayAchieved?: number;
        JuneAchieved?: number;
        JulyAchieved?: number;
        AugustAchieved?: number;
        SeptemberAchieved?: number;
        OctoberAchieved?: number;
        NovemberAchieved?: number;
        DecemberAchieved?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
    }

    export namespace TargetMasterRow {
        export const idProperty = 'TargetId';
        export const localTextPrefix = 'OMS.TargetMaster';
        export const deletePermission = 'Target:Delete';
        export const insertPermission = 'Target:Add';
        export const readPermission = '*';
        export const updatePermission = 'Target:Edit';

        export declare const enum Fields {
            TargetId = "TargetId",
            EmployeeId = "EmployeeId",
            BaseItemTypeId = "BaseItemTypeId",
            ProductTypeName = "ProductTypeName",
            UserId = "UserId",
            EmployeeName = "EmployeeName",
            Quantity = "Quantity",
            Amount = "Amount",
            TargetDistributionId = "TargetDistributionId",
            FinancialYearId = "FinancialYearId",
            JanuaryTarget = "JanuaryTarget",
            FebruaryTarget = "FebruaryTarget",
            MarchTarget = "MarchTarget",
            AprilTarget = "AprilTarget",
            MayTarget = "MayTarget",
            JuneTarget = "JuneTarget",
            JulyTarget = "JulyTarget",
            AugustTarget = "AugustTarget",
            SeptemberTarget = "SeptemberTarget",
            OctoberTarget = "OctoberTarget",
            NovemberTarget = "NovemberTarget",
            DecemberTarget = "DecemberTarget",
            JanuaryAchieved = "JanuaryAchieved",
            FebruaryAchieved = "FebruaryAchieved",
            MarchAchieved = "MarchAchieved",
            AprilAchieved = "AprilAchieved",
            MayAchieved = "MayAchieved",
            JuneAchieved = "JuneAchieved",
            JulyAchieved = "JulyAchieved",
            AugustAchieved = "AugustAchieved",
            SeptemberAchieved = "SeptemberAchieved",
            OctoberAchieved = "OctoberAchieved",
            NovemberAchieved = "NovemberAchieved",
            DecemberAchieved = "DecemberAchieved",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date"
        }
    }
}
